module.exports = __webpack_public_path__ + "static/vib_play5-3b17d5fe1cfa2e55eab81dac8da9469f.jpg";